import { CollectionStateProvider } from 'Context/CollectionStateContext';
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './Container';

export const TaxDiagnosticNotes = ({ relationship }) => {
  return (
    <CollectionStateProvider
      args={{
        link: relationship.link('related'),
      }}
    >
      <Container />
    </CollectionStateProvider>
  );
};

TaxDiagnosticNotes.propTypes = {
  relationship: PropTypes.object.isRequired,
};
